module.exports = "<div class=\"grid grid-pad\">\n  <a *ngFor=\"let imgg of immagini\"  [routerLink]=\"['/dettaglioImmagineBattezzato', imgg.id]\"  class=\"col-1-4\">\n\n    <div class=\"module hero\">\n      <h4>{{imgg.id}}</h4>\n    </div>\n  </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-immagini-battezzati.component.html
// module id = ../../../../../src/app/catalogo/catalogo-immagini-battezzati.component.html
// module chunks = main